import React from 'react'
import '../styles/services.css'
import { Helmet } from 'react-helmet'

const Services = () => {
    return (
        <div id="services">
            <Helmet>
                <title>Services</title>
                <meta property="og:title" content="Remodeling services in Western Washington" />
                <meta name="description" content="Alpha Builders offers all sorts of remodeling services to Western and Central Washington. Kitchen, Flooring, Tile work, Bathroom, Carpentry, Roofing, Siding, and all sorts of home rennovation services" />
                <meta name="keywords" content="alpha builders, home remodeling, kitchen remodeling, flooring services, roofing services, custom carpentry " />
                <meta property="og:image" content="/favicon.ico" />
                <meta property="og:url" content="https://alphabuilders-wa.com/services" />
                <meta property="og:type" content="website" />
            </Helmet>

            <header id='services-header' style={{ backgroundImage: `url('images/tb-6.jpg')` }}>
                <h1>SERVICES</h1>

                <img className='header-icon-2' src='images/services-top-icon.png' />
            </header>
            <div className='brass-gradient' style={{ width: '100%', height: '3px' }}></div>





            <div id='services-alt'>

                <div className='sac-outer brass-gradient'>
                    <div className='services-alt-card sac-left'>
                        <div className='sac-1 '>
                            <div className='sac-icon-cont'>
                                <img src="images/tiles-icon.png" alt='tiles' />
                            </div>

                            <div style={{ backgroundImage: `url('images/tile-bg.jpg')` }} className='sac-img'  >
                            </div>

                        </div>
                        <div className='sac-2'>

                            <div className='sac-title-img'>


                                <h2>TILES</h2>
                            </div>
                            <p>Our tile services offer expert installation and design solutions to elevate any space with style and durability. We specialize in a variety of tile options, including ceramic, porcelain, and natural stone, perfect for floors, walls, and backsplashes. Whether you're updating your kitchen, bathroom, or outdoor areas, our team ensures precision and high-quality results tailored to your vision.</p>
                            <div>



                                <ul>
                                    <li>- Ceramic Tile Flooring</li>
                                    <li>- Porcelain Tile Flooring</li>
                                    <li>- Natural Stone Flooring</li>
                                    <li>- Patio Tile Installation</li>
                                    <li>- Poolside Tiling</li>
                                    <li>- Outdoor Stair Tiling</li>
                                    <li>- Fireplace Surround Tiling</li>
                                </ul>
                            </div>
                        </div>

                    </div>
                </div>



                <div className='sac-outer brass-gradient'>
                    <div className='services-alt-card sac-right'>

                        <div className='sac-2'>

                            <div className='sac-title-img'>


                                <h2>Flooring</h2>
                            </div>
                            <p>Our flooring services provide a variety of stylish and durable options, including hardwood, vinyl, carpet, and more to suit any space. Whether you're upgrading your home or business, we deliver expert installation with high-quality materials for long-lasting results. From cozy interiors to high-traffic areas, we ensure flooring solutions that blend aesthetics with functionality.</p>
                            <div>



                                <ul>
                                    <li>- Hardwood Flooring</li>
                                    <li>- Vinyl Flooring</li>
                                    <li>- Carpet Installation</li>
                                    <li>- Garage Flooring</li>
                                    <li>- Rubber Flooring</li>
                                    <li>- Tile Flooring</li>
                                </ul>
                            </div>
                        </div>

                        <div className='sac-1 '>
                            <div className='sac-icon-cont'>
                                <img src="images/floor-icon.png" alt='flooring icon' />
                            </div>

                            <div style={{ backgroundImage: `url('images/floor-bg.jpg')` }} className='sac-img'  >
                            </div>

                        </div>

                    </div>
                </div>


                <div className='sac-outer brass-gradient'>
                    <div className='services-alt-card sac-left'>
                        <div className='sac-1 '>
                            <div className='sac-icon-cont'>
                                <img src="images/kitchen-icon.png" alt='kitchen icon' />

                            </div>

                            <div style={{ backgroundImage: `url('images/wc-2.png')` }} className='sac-img'  >
                            </div>

                        </div>
                        <div className='sac-2'>

                            <div className='sac-title-img'>

                                <h2>KITCHEN</h2>
                            </div>
                            <p>Our kitchen services offer expert design and installation solutions to create functional and stylish spaces tailored to your needs. From custom cabinetry and countertops to modern backsplashes and flooring, we ensure high-quality craftsmanship that enhances both aesthetics and efficiency. Let us bring your dream kitchen to life with our professional touch.</p>
                            <div>



                                <ul>
                                    <li>- Kitchen Remodels</li>
                                    <li>- Kitchen Cabinets</li>
                                    <li>- Kitchen Backsplash</li>
                                    <li>- Kitchen Appliance Installation</li>
                                    <li>- Kitchen Islands</li>
                                    <li>- Kitchen Countertops</li>
                                </ul>
                            </div>
                        </div>

                    </div>
                </div>




                <div className='sac-outer brass-gradient'>
                    <div className='services-alt-card sac-right'>

                        <div className='sac-2'>

                            <div className='sac-title-img'>

                                <h2>BATHROOM</h2>


                            </div>
                            <p>Our bathroom remodeling services focus on transforming your space with stylish and functional designs tailored to your needs. From custom vanities and elegant tiling to modern fixtures and lighting, we provide high-quality craftsmanship to enhance both aesthetics and comfort. Whether you're looking for a complete renovation or a simple update, our team ensures a seamless and beautiful transformation.</p>
                            <div>



                                <ul>
                                    <li>- Bathroom Remodels</li>
                                    <li>- Bathroom Vanity's</li>
                                    <li>- Bathroom Backsplash</li>
                                    <li>- Shower and Bathtub</li>
                                    <li>- Bathroom Flooring</li>
                                </ul>
                            </div>
                        </div>

                        <div className='sac-1 '>
                            <div className='sac-icon-cont'>
                                <img src="images/bathroom.png" alt='bathroom icon' />
                            </div>

                            <div style={{ backgroundImage: `url('images/bathroom-bg.jpg')` }} className='sac-img'  >
                            </div>

                        </div>

                    </div>
                </div>



                <div className='sac-outer brass-gradient'>
                    <div className='services-alt-card sac-left'>
                        <div className='sac-1 '>
                            <div className='sac-icon-cont'>
                                <img src="images/carpentry.png" alt='carpentry icon' />

                            </div>

                            <div style={{ backgroundImage: `url('images/carpent.jpg')` }} className='sac-img'  >
                            </div>

                        </div>
                        <div className='sac-2'>

                            <div className='sac-title-img'>

                                <h2>CARPENTRY</h2>
                            </div>
                            <p>Our carpentry services provide expert craftsmanship to bring your vision to life, whether it’s custom-built furniture, cabinetry, or intricate woodwork. We specialize in creating durable, stylish, and functional solutions that enhance both residential and commercial spaces. From small upgrades to complete renovations, our attention to detail ensures high-quality results that stand the test of time..</p>
                            <div>



                                <ul>
                                    <li>- Framing</li>
                                    <li>- Roofing</li>
                                    <li>- Windows</li>
                                    <li>- Doors</li>
                                    <li>- Trim</li>
                                    <li>- Fences</li>

                                </ul>
                            </div>
                        </div>

                    </div>
                </div>


            </div>



        </div>
    )
}

export default Services